import { render, staticRenderFns } from "./storeOrderCartReturnList.vue?vue&type=template&id=63aef83a&scoped=true"
import script from "./storeOrderCartReturnList.vue?vue&type=script&lang=js"
export * from "./storeOrderCartReturnList.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartReturnList.vue?vue&type=style&index=0&id=63aef83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aef83a",
  null
  
)

export default component.exports